export default {
	"masterData": {
        // credit term
		"1day": "1 วัน",
        "3day": "3 วัน",
        "15day": "15 วัน",
        "30day": "30 วัน",
        "45day": "45 วัน",
        "60day": "60 วัน",
        "90day": "90 วัน",
        "120day": "120 วัน",
        // payment type
        "cheque": "รับเช็ค",
        "cash": "เงินสด",
        "bankTransfer": "โอนเงินระหว่างบัญชี",
        "postpaid": "จ่ายเงินหลังรับบริการ",
        "company": "นิติบุคคล",
        "individual": "บุคคลธรรมดา",
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/masterData/index.js